export default {
    F: {
        APODERADO: 'Apoderado',
        AUTORIZADO: 'Autorizado operativo',
        AUTORIZADO_CONSULTA: 'Autorizado consultivo',
        NUDO_PROPIETARIO: 'Nudo propietario',
        USUFRUCTUARIO: 'Usufructuario',
        TITULAR: 'Titular',
        // BENEFICIARIO: 'Beneficiario',
        APORTANTE_CONYUGE: 'Aportante conyuge',
        APORTANTE_FAMILIAR: 'Aportante familiar',
        REPRESENTANTE_LEGAL: 'Representante legal',
        TUTOR: 'Tutor'
    },
    J: {
        ADMINISTRADOR: 'Administrador',
        APODERADO: 'Apoderado',
        TITULAR: 'Titular',
        REPRESENTANTE_LEGAL: 'Representante legal',
        JUNTA_DIRECTIVA: 'Junta directiva'
    },
    all: {
        APODERADO: 'Apoderado',
        AUTORIZADO: 'Autorizado operativo',
        AUTORIZADO_CONSULTA: 'Autorizado consulta',
        NUDO_PROPIETARIO: 'Nudo propietario',
        USUFRUCTUARIO: 'Usufructuario',
        TITULAR: 'Titular',
        APORTANTE_CONYUGE: 'Aportante conyuge',
        APORTANTE_FAMILIAR: 'Aportante familiar',
        REPRESENTANTE_LEGAL: 'Representante legal',
        TUTOR: 'Tutor',
        ADMINISTRADOR: 'Administrador',
        JUNTA_DIRECTIVA: 'Junta directiva'
    }
};
